// extracted by mini-css-extract-plugin
module.exports = {"lowerContent":"SettingsSidebarMenu_lowerContent__3k_mp","sending":"SettingsSidebarMenu_sending__3Db64"};